import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    FRANCHISE_PAGE_LOADING() {
      return {
        isLoading: true,
        franchisePage: action.franchisePage
      };
    },
    FRANCHISE_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const category = get(
        action,
        'franchisePage.franchiseCategory',
        'franchise-page'
      );
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        category,
        'franchisePage'
      );
      return {
        isLoading: false,
        data: action.franchisePage,
        ads: adModelData
      };
    },
    FRANCHISE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.franchisePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
